module.exports = __webpack_public_path__ + "img/gift3-01-c04.c8be1ab3.png";